import Vue from 'vue';
import Vuex from 'vuex';

import loadData from './loadData';
import profile from './profile';
import listContract from './listContract/contract';
import type_contract from './master/type_contract';
import role from './master/role';
import roleManagement from './role_management/role';
import notification from './notification/list';
import dashboard from './dashboard';
import users from './master/users';
import organization from './master/organization';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		loadData,
		profile,
		type_contract,
		roleManagement,
		listContract,
		notification,
		role,
		dashboard,
		users,
		organization,
	},
});
